import PUBLIC_ROUTES from '@routes/publicRoutes';
import MAIN_ROUTES from '@routes/mainRoutes';
// import CONFIG_ACCOUNT_ROUTES from '@routes/configAccountRoutes';

const ROOT_ROUTES = [
  ...PUBLIC_ROUTES,
  ...MAIN_ROUTES,
  // ...CONFIG_ACCOUNT_ROUTES,
  // {
  //   path: '/temp-timeline',
  //   key: 'TEMP',
  //   exact: true,
  //   component: SelectTwo,
  // },
];

const flatRoutes = ROOT_ROUTES.reduce((accumulator, current) => {

  const { routes = [], ...mainRoute } = current;

  const findMultiples = routes.filter((item) => item.path && Array.isArray(item.path));
  if (findMultiples.length > 0) {

    const multiplesRoutes = findMultiples.reduce((acc, cur) => {

      const { menuItem, path: paths, ...rest } = cur;

      // eslint-disable-next-line no-param-reassign
      if (Array.isArray(menuItem)) acc = [...acc, ...menuItem];
      else {

        const newItems = paths.map((path) => ({ path, ...rest }));
        // eslint-disable-next-line no-param-reassign
        acc = [...acc, ...newItems];

      }

      return acc;

    }, []);

    // eslint-disable-next-line no-param-reassign
    accumulator = [...accumulator, mainRoute, ...routes, ...multiplesRoutes];
    return accumulator;

  }

  // eslint-disable-next-line no-param-reassign
  accumulator = [...accumulator, mainRoute, ...routes];
  return accumulator;

}, []);

export function findRouteWithKey(keyTarget) {

  const routeTarget = flatRoutes.find(({ key }) => keyTarget === key);
  return routeTarget;

}

export function findRouteWithPath(pathTarget) {

  const routeTarget = flatRoutes.find(({ path }) => pathTarget === path);
  return routeTarget;

}

export default ROOT_ROUTES;
